"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dotDivider = exports.lineDivider = void 0;

var _reactEmotion = require("react-emotion");

// import { withTheme } from 'emotion-theming';
var lineDivider = function lineDivider(_ref) {
  var color = _ref.color;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("width:100%;background:", color.grey2, ";height:1px;")
  );
};

exports.lineDivider = lineDivider;

var dotDivider = function dotDivider(_ref2, size) {
  var color = _ref2.color;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:inline-block;background:", color.grey2, ";height:", size || 4, "px;width:", size || 4, "px;border-radius:50%;")
  );
}; // export default withTheme(styled.div`${lineDivider}`);


exports.dotDivider = dotDivider;